<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs12 lg4>
        <span class="headline">Participantes</span>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg4 class="text-xs-right">
        <v-btn color="primary" @click="create(false)" class="mb-4" :disabled="task_shared || !task.crud_access">
          {{this.translate('system.button.add.title')}}
          <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <h2 style="font-weight:normal;">Usuários</h2>
      </v-flex>
      <!--Dialog para confirmação de exclusão-->
      <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="processDeleteItem" @cancel="closeDialogDelete"></p-confirm>
      <!--Index-->
      <v-flex xs12>
        <v-data-table
          no-data-text="Ainda não foram cadastrados registros de Participantes"
          rows-per-page-text="Registros por página"
          :headers="headers"
          :items="items"
          :search="search"
          :rows-per-page-items="[10,20,30,{'text':'Todos','value':-1}]"
          hide-actions
          class="elevation-1"
          :custom-filter="customizedFilter" style="word-break: break-all;">
          <template slot="items" slot-scope="props">
            <td v-if="!props.item.user_id">{{''}}</td>
            <!-- // usa o this.$auth.check() pois caso o usuário não esteja logado não pega a empresa, ocorre em tarefas compartilhadas -->
            <td v-else-if="task.company_id === ($auth.check() ? $auth.user().company_id : 0)">{{ props.item.user.id_text+(props.item.connection_company ? ('('+props.item.connection_company.id_text+')') : '')}}</td>
            <td v-else-if="props.item.connection_company_id">{{ props.item.user.id_text+(props.item.connection_company_id === ($auth.check() ? $auth.user().company_id : 0) ? '' : ('('+props.item.connection_company.id_text+')')) }}</td>
            <td v-else>{{ props.item.user.id_text+((' ('+task.company.id_text+')'))}}</td>
            <td>{{ props.item.note }}</td>
            <td align="center" style="min-width: 110px">
              <v-btn icon class="mx-0" @click="editItem(props.item)" :disabled="task_shared || !task.crud_access">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="dialogDelete(props.item)" :disabled="task_shared || !task.crud_access">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12>
        <h2 style="font-weight:normal;">Outros</h2>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          no-data-text="Ainda não foram cadastrados registros de Participantes Externos"
          rows-per-page-text="Registros por página"
          :headers="headersExternos"
          :items="itemsExternal"
          class="elevation-1"
          hide-actions>
          <template slot="items" slot-scope="props">
            <td width='20%'>{{ props.item.id_text }}</td>
            <td width='20%'>{{ props.item.email }}</td>
            <td width='40%'>{{ props.item.note }}</td>
            <td align="center" style="min-width: 110px">
              <v-btn icon class="mx-0" @click="editItem(props.item)" :disabled="task_shared || !task.crud_access">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="dialogDelete(props.item)" :disabled="task_shared || !task.crud_access">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" @keyup.native.esc="closeProcess(400)" @keyup.native.ctrl.enter="save()" ref="form">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex v-show='view !== 3' xs12>
                  <v-radio-group v-model="editedItem.radio_type" row @change="changeType">
                    <v-radio label="Usuários" :value="1"></v-radio>
                    <v-radio label="Outros" :value="2"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-layout wrap v-if="editedItem.radio_type === 2">
                <v-flex xs12 md4>
                  <v-text-field ref="autofocus" maxlength="190" counter="190"  :label="translate('table.' + entity + '.field.id_text')"
                                v-model="editedItem.id_text" :rules="requiredRule(translate('table.' + entity + '.field.id_text'))"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field :label="translate('table.' + entity + '.field.email')"
                                v-model="editedItem.email"
                                :rules="emailRule(translate('table.' + entity + '.field.email'), true, false)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field :label="translate('table.' + entity + '.field.note')"
                                v-model="editedItem.note"></v-text-field>
                </v-flex>
                </v-layout>
                <v-layout wrap v-else align-center>
                  <v-flex :class="view === 3 ? 'xs12' :'xs12 md6'">
                    <span style="font-size: 12pt;font-weight: 600;" v-if="view === 3">{{selectedUser.id_text}}</span>
                    <p-select-user id="task_user_user_id" v-else ref="userIllis" v-model="selectedUser" :rules="requiredRule(translate('table.' + entity + '.field.user_id'))" :users="users" :label="translate('table.' + entity + '.field.user_id')" @input="changeResponsible" :itemsNotShow="itemsNotShow" :outCompanyId="task['company_id']"></p-select-user>
                  </v-flex>
                  <v-flex :class="view === 3 ? 'xs12' :'xs12 md6'">
                    <v-text-field :label="translate('table.' + entity + '.field.note')"
                                  v-model="editedItem.note" name="note"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="processSave">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="closeProcess(400)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  /* eslint-disable eqeqeq */
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import PConfirm from './../shared/PConfirm'
  import PSelectUser from './../shared/PSelectUser'

  export default {
    mixins: [crud, rules],
    components: {PConfirm, PSelectUser},
    data: () => ({
      entity: 'task_user',
      selectedUser: null,
      itemsExternal: []
    }),
    name: 'TaskUser',
    props: {
      task: {
        type: Object,
        default: function () { return {} }
      },
      // caso venha users do componete acima usa eles
      users: {
        type: Array,
        default: function () { return [] }
      },
      task_shared: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.items = this.task.users
      // this.users = this.users
      this.itemsExternal = this.task.users_external
      this.editedItem = {task_id: this.task.id, connection_id: '', connection_company_id: '', manager: false, id_text: '', email: '', note: '', radio_type: 1}
      this.defaultItem = {task_id: this.task.id, connection_id: '', connection_company_id: '', manager: false, id_text: '', email: '', note: '', radio_type: 1}
    },
    mounted: function () {
      this.$emit('itemsLength', this.items.length + this.itemsExternal.length)
    },
    methods: {
      closeProcess (time) {
        this.close(time)
        this.changeResponsible(null)
      },
      processSave (res) {
        if (this.editedItem.radio_type === 2) {
          if (this.view === 2) {
            this.saveValue('task_user_external', this.editedItem, 'Participante Externo', false)
          } else if (this.view === 3) {
            this.editValue('task_user_external', this.editedItem, 'Participante Externo', false, false)
          }
        } else {
          this.save()
        }
      },
      afterSaveValue (resBody) {
        this.itemsExternal.push(resBody)
        this.$emit('itemsLength', this.items.length + this.itemsExternal.length)
        this.$socket.emit('generalDetailsEvent', {
          data: resBody,
          details: 'users_external',
          responseEvent: 'addSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
      },
      afterEditValue (resBody) {
        Object.assign(this.itemsExternal.find((res) => { return res.id === resBody.id }) || {}, resBody)
        this.$socket.emit('generalDetailsEvent', {
          data: resBody,
          details: 'users_external',
          responseEvent: 'editSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
      },
      afterDeleteValue (resBody) {
        this.itemsExternal = this.itemsExternal.filter((val) => { return val.id !== resBody.id })
        this.$emit('itemsLength', this.items.length + this.itemsExternal.length)
        this.$socket.emit('generalDetailsEvent', {
          data: resBody,
          details: 'users_external',
          responseEvent: 'deleteSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
      },
      processDeleteItem () {
        if (this.editedItem.hasOwnProperty('user_id') && (this.editedItem.user_id > 0)) {
          this.deleteItem(this.editedItem)
        } else {
          this.deleteValue('task_user_external', this.editedItem, 'Participante Externo', false)
        }
      },
      afterInsert (res) {
        this.$emit('itemsLength', this.items.length + this.itemsExternal.length)
        // Evento que será emitido para adição de detalhes, neste caso, os participantes que foram adicionados.
        // Este evento será emitido para somente para quem estiver na tela de gerenciamento
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'users',
          responseEvent: 'addSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        for (let user in this.task.participants) {
          this.$socket.emit('generalDetailsEvent', {
            data: res,
            details: 'users',
            responseEvent: 'addSocketItemDetails',
            room: `tasks${this.task.participants[user]}`
          })
        }
        if (this.task.user_id !== res.user_id) {
          this.$socket.emit('generalEvent', {
            data: this.task,
            responseEvent: 'addSocketItem',
            room: `tasks${res.user_id}`
          })
          this.$socket.emit('generalEvent', {
            data: [this.task.task_status_id],
            responseEvent: 'reloadStatusPage',
            room: `kanban${res.user_id}`
          })
          this.$socket.emit('generalEvent', {
            data: this.task,
            responseEvent: 'addSocketCalendarTask',
            room: `calendar${res.user_id}`
          })
        }
        this.changeResponsible(null)
      },
      afterUpdate (res) {
        let temp = {old_user_id: this.beforeEditedItem.user_id}
        Object.assign(temp, res)
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'users',
          responseEvent: 'editSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        for (let user in this.task.participants) {
          this.$socket.emit('generalDetailsEvent', {
            data: temp,
            details: 'users',
            responseEvent: 'editSocketItemDetails',
            room: `tasks${this.task.participants[user]}`
          })
        }
        this.changeResponsible(null)
      },
      afterDelete (res) {
        let temp = {old_user_id: res.user_id}
        Object.assign(temp, res)
        this.$emit('itemsLength', this.items.length + this.itemsExternal.length)
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'users',
          responseEvent: 'deleteSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        for (let user in this.task.participants) {
          this.$socket.emit('generalDetailsEvent', {
            data: temp,
            details: 'users',
            responseEvent: 'deleteSocketItemDetails',
            room: `tasks${this.task.participants[user]}`
          })
        }
        if (this.task.user_id !== res.user_id) {
          this.$socket.emit('generalEvent', {
            data: {id: this.task.id, delTaskUsers: [res.user_id]},
            responseEvent: 'deleteSocketItem',
            room: `tasks${res.user_id}`
          })
          this.$socket.emit('generalEvent', {
            data: this.task,
            responseEvent: 'deleteSocketCalendarTask',
            room: `calendar${res.user_id}`
          })
        }
        this.changeResponsible(null)
      },
      beforeCreate () {
        this.changeType(1)
      },
      afterEditItem () {
        // Caso tenha usuário no momento de editar cria a estrutura do usuário para o pSelectUser aceitar
        if (this.editedItem.user_id) {
          let userIndex = {
            company_id: this.editedItem.connection_company_id ? this.editedItem.connection_company_id : this.$auth.user().company_id,
            company_id_text: this.editedItem.connection_company ? this.editedItem.connection_company.id_text : null,
            connection_id: this.editedItem.connection_id,
            email: this.editedItem.user.email,
            id: `${this.editedItem.user_id}-${this.editedItem.connection_company_id ? this.editedItem.connection_company_id : this.editedItem.company_id}`,
            id_text: `${this.editedItem.user.id_text} (${this.editedItem.user.email})`,
            logo_path: this.editedItem.connection_company ? this.editedItem.connection_company.logo_path : null,
            photo_path: this.editedItem.user.photo_path,
            user_id: this.editedItem.user_id
          }
          if (userIndex) {
            this.selectedUser = userIndex
          }
        }
        if ((this.editedItem.user_id) > 0) {
          this.editedItem.radio_type = 1
        } else {
          this.editedItem.radio_type = 2
        }
      },
      changeResponsible (val) {
        if (val && val.id !== null && val.id !== {}) {
          this.selectedUser = val
          this.editedItem.user_id = val.user_id
          this.editedItem.connection_id = val.connection_id
          this.editedItem.connection_company_id = (val.company_id != this.$auth.user().company_id ? val.company_id : null)
        } else {
          this.selectedUser = null
          this.editedItem.user_id = null
          this.editedItem.connection_id = null
          this.editedItem.connection_company_id = null
        }
      },
      changeType (val) {
        this.$refs.form.resetValidation()
        this.editedItem.user_id = null
        this.editedItem.connection_id = null
        this.editedItem.manager = false
        this.editedItem.id_text = ''
        this.editedItem.email = ''
        this.editedItem.note = ''
      }
    },
    computed: {
      // Valores que já foram incluidos na lista, para que o pSelectuser não mostre eles
      itemsNotShow: function () {
        var items = []
        // usa o this.$auth.check() pois caso o usuário não esteja logado não pega a empresa, ocorre em tarefas compartilhadas
        let companyId = this.$auth.check() ? this.$auth.user().company_id : 0
        this.items.map((val) => {
          items.push(`${val.user_id}-${val.connection_company_id ? val.connection_company_id : companyId}`)
        })
        return items
      },
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.user_id'), value: 'user.id_text', width: '50%'},
          {text: this.translate('table.' + this.entity + '.field.note'), value: 'note', width: '40%'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      },
      headersExternos: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.user_id'), value: 'id_text', width: '25%'},
          {text: this.translate('table.' + this.entity + '.field.email'), value: 'email', width: '25%'},
          {text: this.translate('table.' + this.entity + '.field.note'), value: 'note', width: '40%'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/details/TaskUser.vue